module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "prol"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "dl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("MONDAY, MAY 10, 1999")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("The call from dispatch is such a provocation it causes him to jerk the cruiser off the street into a parking lot, slam the transmission into "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PARK")]), _vm._v(", and just sit there, working up a major case of the red ass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He can tell already what this is about, been down this road many a time, thinking now that when a man abides in a world that’s bathed in racism, invisible yet still there all the time, like the radiation from the stars, so that he’s always awash in it, he develops his own sensing mechanism attuned to it. He can calibrate it and triangulate it, can measure its strength.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s like he’s got some kind of racism meter, built right into his brain, and it tracks down the racism in the world as it pertains to him, giving him readings. When it’s stronger, when it’s weaker.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When there’s a concentrated burst of it coming from somewhere close, taking dead aim at him, penetrating the cells in his body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sheriff’s Deputy C. Livermore Thomas breathes deep, thumbs the mike.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“C’mon, Darlene, gimme a break.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sorry, Clyde.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sorry, huh. Saying it don’t make it so, Darlene, don’t believe I hear no ‘sorry’ in your voice. You know what I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("do")]), _vm._v(" believe though? I believe ol’ Clyde’s being jacked around, you know what I’m sayin’?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He waits for her to come back at him, thinking if she disses him, gives him any kind of a reason "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("at all")]), _vm._v(" to think she might be dissing him, he’s just going to rip this mike, cord and all, out of the radio, chuck it out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She says, “You know what the sneaker ads say, Clyde. Just do it, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His racism meter gives him another reading, needle all the way over in the “they really fuckin’ with you now” zone. He’s thinking, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Okay, got to stay cool, come on back at old dispatch now, stand up for your human rights, use a little sweet reason")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whine some even.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Come on")]), _vm._v(". I’m meetin’ Sonya for lunch in, what”—he checks the dashboard clock—“less than an hour. I can’t go chasin’ all the way out to the county line on account of some fool say he turned up a suspicious-looking "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("boot")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The man says it looks peculiar. He’s ’fraid it might be a body.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s a boot, out in a pasture, nothin’ suspicious about it. Some country folks threw their trash out, old boot was part of it, that’s all. You from the country, Darlene, you know what I’m talkin’ ’bout here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Clyde, all I know is he’s worried enough about it to call it in.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Darlene, this here’s Washington County, okay? We don’t have no real crime ’round here. For sure ain’t no dead bodies, except those in the graveyard. This fool you say called in, he ain’t tryin’ to drill a oil well in a graveyard is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, there you go then.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Clyde, just get your ass out there, check it out, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that")]), _vm._v(" moves the needle on the racism meter. All she said was “ass,” but Clyde knows she was thinking “black ass.” She like to said it, too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde sets his jaw, thumbs the mike. “Get somebody else. How ’bout Jake?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Workin’ a speed trap, out on Thirty-six. Citin’ ’em so fast, he’s gettin’ writer’s cramp.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So what, if it’s a real dead body and all out yonder?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Pays the bills, Clyde.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What about the sheriff then?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’s in some meeting over at the bypass, told me not to disturb him for nothin’ short of Bonnie and Clyde.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Darlene, this here is bullshit and you know it. You keep treatin’ me this way, disrespectin’ me and all, I’m gonna know you a racist like everybody else in this cracker town, you know what I’m sayin’?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Clyde, I’m fixing to read the directions to you. You ready to write ’em down?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, but this is bullshit.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He scribbles down the route while she reads it to him. “Okay, I got ’em. But this here is bullshit plain and simple.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Over and out, Clyde.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Over and out your own self.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde spikes the microphone off the front seat, pulls a U out of the parking lot, headed west now, punches the accelerator. He’s thinking, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sonya’s a pro, she’ll understand, plus she’s seen this sort of thing before where we’re concerned, many a time, many a time indeed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the thought of being late sets his teeth to grinding. He hates being late worse than anything. His mama had drilled it into him, ever since he was little, running around barefoot in the dirt yard out front of their shotgun house up in Oak Cliff. She said cleanliness was important all right, but it was punctuality that was next to godliness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Once he gets to the city limits Clyde kicks the cruiser, and directly he’s howling down the road doing ninety. He hits the siren, the lights. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("That’s right, let’s give the taxpayers their money’s worth.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now he’s out in the country, no neat little rows of houses with landscaped yards out here, instead there’s farms, ranches, cows, yard dogs, double-wides set way back from the highway with great big satellite dishes next to them, guys in straw hats and overalls driving farm equipment down the side of the road.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The scenery whips by and all around smoke hangs so thick in the air it blocks out the sun, renders the sky metallic, the color of corrugated tin or old asphalt, like the sky of another time, some primordial time when the world was young, primitive, volcanic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde hangs a left on Farm Road 390, part of the “Bluebonnet Trail,” according to the sign. “Damn if these people don’t love their bluebonnets,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A half-mile farther on there’s another left, this one onto a dirt road, barbed-wire fence running down both sides. It goes for a ways, then there’s a break in the fencing on the right, got a cattle guard there Clyde has to rumble over, then on to another dirt road, this one winding through a dusty pasture, leading up a short hill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yo, check out this road, man.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bouncing over this rutted-out mess, little more than a cow path, Clyde can’t go faster than twenty, else he’s apt to bust something loose from the undercarriage. As it is he’s being tossed around in his seat as if his cruiser were a carnival ride even though he’s barely going funeral procession speed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Crabbing along like this, he realizes, the siren and the lights, they’re idiotic. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Better kill the lights and the sound before somebody sees me. There’s no taxpayers out here anyhow, just these cows standin’ around with their tails switchin’ back and forth. And, man, talk about dry.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde checks the rearview, nothing to be seen but a cloud of dust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’s thinking, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Goddamn this for the jive bullshit it is")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He lurches over the hill, then another quarter-mile downhill into a pasture where there’s half a dozen guys in coveralls and hard hats standing around, leaning up against their pickups, parked this way and that. There’s a bulldozer and a sizable area, maybe a couple acres, where the weeds and grass have been scraped away leaving dry brown dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde parks the cruiser, gets out. A big guy walks up, got a face the color of a raw beef brisket. What with his red face and blue coveralls, the matching hard hat, the white lettering that says “Mexia Drilling Company,” reminds Clyde of the American flag.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The flag-colored guy sticks his hand out for a shake. “Peter Wells,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Deputy Clyde Thomas. Pleased to meet you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks for coming. It’s over here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Brisket Face leads Clyde across the cleared patch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’ve been working this spot for two days, clearing it and leveling it. Got a new well planned. Drilling’s supposed to begin next Wednesday. I was walking the perimeter when I looked down, saw the toe of a cowboy boot stickin’ up out of the ground.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Cowboy boot, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah. I thought it looked suspicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“’As what I hear. This being like out in the country and all, maybe somebody just dumped a load of trash with a boot in it, here in this pasture. You think of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, yeah. But no one’s living around here. There’s no houses or nothin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Uh-huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And we haven’t turned up any other trash since we been out here pushing dirt around. Struck me as strange so I’m thinking better safe than sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Better safe than sorry, huh. That’s a good one. You make that up?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, no—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why don’t you just show me where the boot is at?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The oil driller stops at the edge of the cleared area, points downward. “That’s it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just like the man had said, there’s the toe of a cowboy boot sticking up a couple inches out of the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde leans down, getting himself a closer look. “Can I get a shovel from y’all?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure. Hey, Dennis,” Peter Wells hollers, “fetch a shovel over here, will ya?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another flag-looking guy—same beef-brisket face, blue duds, belly on him big enough to have its own gravitational field—ambles over with a shovel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde takes it, starts scraping at the dirt around the boot, a couple feet on either side, looking for the rest of the trash pile, sure it’s there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’s thinking, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Finish this bullshit up and still get lunch with Sonya.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The shovel catches a few times, but on rocks and roots, not trash. Clyde tosses the shovel aside. He pulls out a handkerchief, wipes his brow, trying to think it through.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("You could just jerk the boot out of the ground, see if anything is attached, like somebody’s leg maybe. But if it’s a body then you’d be messing with a crime scene right here in front of these oil guys with their side-of-beef faces and their blue jumpsuits, make great witnesses for some defense lawyer.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Or else you could back up, get a warrant, do a full crime-scene search, take a day, involve half the department.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Yeah, and if it turns out to be nothing but a stray boot you’ll be catching shit about it for weeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The thing is to check it out, but not disturb nothin’ too much.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde fishes in his pocket for a knife, kneels down, starts cutting the boot where the upper is sewed to the sole. He cuts around the toe and down each side about an inch. Pockets the knife, bends the upper back from the sole, peers in. Has to get down on one knee real close, squint. “Motherfucker.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde straightens back up, looks at the Brisket Twins. “I think we might have ourselves a potential crime scene here, which means I need to get me a search warrant, alright? Now why don’t the two of y’all just back up a ways while I go call this in? Don’t touch nothin’ and don’t be walkin’ around here none, you know what I’m sayin’?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Back at the cruiser, he leans in, grabs the mike. “Yo, Darlene.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Come in, Clyde.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I got me a honest-to-God dead person out here. Or at least part of one.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I said it looks like the tip is gonna check out. Now maybe it ain’t exactly Bonnie and Clyde, but why don’t you find the sheriff and tell him to get out here, you know what I’m sayin’? And call the DPS, see if they can locate us a forensic anthropologist.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A forensic anthropologist.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How you spell that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Shit, I don’t know. Look it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Clyde signs off, says to himself, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A man don’t need a warrant to make notes, take a few snaps, right?")]), _vm._v(" Clyde goes to the trunk, pulls out a camera and a notebook. He checks the camera for film and batteries, starts back to where the boot is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’s thinking, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Now wouldn’t that be something? A no-shit homicide, right here in Pig Fart, Texas, real-live police work to be done, instead of days of doing nothing but handing out traffic tickets to Billy Bobs in pickups.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’s thinking, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("This might actually turn out to be kind of cool")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("At that moment, less than a mile away, a tall, lean, gray-haired man with blue eyes and a jaw on him that looks like it belongs on Mount Rushmore, a retired Texas Ranger dressed in rancher’s khakis, is hauling hay to his cattle, trying to get his chores done so he can go down to Houston, see his daughter, sick these many months in a hospital down yonder. He labors away in the heat and smoke, oblivious to Clyde’s discovery, to the implications of it for him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He won’t stay that way for long.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caced76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0